import React, { useState } from 'react'
import { ButtonAD } from '@imedcl/design-system'

export const ModalErrorEmailNotFound = ({ onClose }) => {
  const [width, setWidth] = useState('700px')

  return (
    <div className='flex justify-center items-center overflow-hidden fixed inset-0 outline-none focus:outline-none bg-white/70 backdrop-blur-sm z-[9999999999999]'>
      <div className=''>
        <div
          style={{ width }}
          className={`translate duration-300 p-10 bg-white rounded-lg shadow-lg border relative w-[608px]`}
        >
          <div className='mb-8'>
            <p className='text-center text-lg font-bold text-secondary-imed-60 mb-8'>
              Confirmación de email y código de validación
            </p>
            <div className='bg-red-200 rounded-md p-4'>
              <p className='font-semibold text-red-800 text-lg mb-2'>
                No obtuvimos un email para enviarte el código.
              </p>
              <p className='text-lg text-red-800 mb-4 leading-6'>
                Contáctanos a cobranzas@imed.cl para regularizar tu situación indicando este
                problema.{' '}
              </p>
            </div>
          </div>
          <div className='flex justify-end'>
            <ButtonAD text={'Aceptar'} onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  )
}
